import React, { useCallback } from 'react'
import { Z_INDEX_ONSITE_MODAL } from '../../../../layout/zIndex'
import { OnsiteModal } from '../../../../ui/OnsiteModal/OnsiteModal'
import { usePaymentStatusModalContext } from '../../providers/PaymentStatusModalProvider'
import { PaymentStatusCard, PaymentStatusCardProps } from './PaymentStatusCard'

export const PaymentStatusModal = React.memo<PaymentStatusCardProps>(props => {
  const { hidePaymentStatusModal } = usePaymentStatusModalContext()
  const { type, mode } = props
  const onClose = useCallback(() => {
    if (type !== 'payment-processing') {
      hidePaymentStatusModal()
    }
  }, [hidePaymentStatusModal, type])

  return (
    <OnsiteModal
      modalZIndexClassName={`z-[${Z_INDEX_ONSITE_MODAL}]`}
      size={mode === 'embedded' ? 'default' : 'large-width'}
      onClose={onClose}
    >
      <PaymentStatusCard {...props} onClose={onClose} />
    </OnsiteModal>
  )
})

PaymentStatusModal.displayName = 'PaymentStatusModal'
